module.exports = __webpack_public_path__ + "img/fracpacks.03168899.png";